import { Action as RewardTrigger, DiscountType, Type as RewardType } from '@wix/ambassador-loyalty-referral-v1-program/types';
import { ReferralAction } from './constants';
const rewardTriggerToReferralActionMap = {
  [RewardTrigger.STORE_ORDER_PLACED]: ReferralAction.StoreOrderPlaced,
  [RewardTrigger.PLAN_ORDERED]: ReferralAction.PricingPlanOrdered,
  [RewardTrigger.TICKET_ORDERED]: ReferralAction.EventTicketOrdered,
  [RewardTrigger.SESSION_BOOKED]: ReferralAction.SessionBooked,
  [RewardTrigger.RESTAURANT_ORDER_PLACED]: ReferralAction.RestaurantOrderPlaced,
  [RewardTrigger.ONLINE_PROGRAM_JOINED]: ReferralAction.OnlineProgramJoined
};
export function getCustomerRewardTitle(_ref, program) {
  var _program$successfulRe;
  let {
    t,
    formatNumber,
    formatCurrency,
    customPointsName
  } = _ref;
  const rewardTrigger = (_program$successfulRe = program.successfulReferralActions) == null ? void 0 : _program$successfulRe[0];
  const reward = program.referringCustomerReward;
  if (!reward || !rewardTrigger) {
    return '';
  }
  const referralAction = rewardTriggerToReferralActionMap[rewardTrigger];
  if (reward.type === RewardType.COUPON) {
    const {
      couponOptions
    } = reward;
    if ((couponOptions == null ? void 0 : couponOptions.discountType) === DiscountType.FREE_SHIPPING) {
      return t(`customer.free-shipping.${referralAction}`);
    } else if ((couponOptions == null ? void 0 : couponOptions.discountType) === DiscountType.PERCENTAGE) {
      var _couponOptions$percen;
      const amount = couponOptions == null || (_couponOptions$percen = couponOptions.percentageOptions) == null ? void 0 : _couponOptions$percen.percentage;
      if (amount !== undefined) {
        const percentage = `${formatNumber(amount)}%`;
        return t(`customer.discount.${referralAction}`, {
          amount: percentage
        });
      }
    } else if ((couponOptions == null ? void 0 : couponOptions.discountType) === DiscountType.FIXED_AMOUNT) {
      var _couponOptions$fixedA;
      const amount = couponOptions == null || (_couponOptions$fixedA = couponOptions.fixedAmountOptions) == null ? void 0 : _couponOptions$fixedA.amount;
      if (amount !== undefined) {
        return t(`customer.discount.${referralAction}`, {
          amount: formatCurrency(amount)
        });
      }
    }
  } else if (reward.type === RewardType.LOYALTY_POINTS) {
    var _reward$loyaltyPoints;
    const amount = (_reward$loyaltyPoints = reward.loyaltyPointsOptions) == null ? void 0 : _reward$loyaltyPoints.amount;
    if (amount !== undefined) {
      if (customPointsName) {
        return t(`customer.points.${referralAction}.custom`, {
          amount: formatNumber(amount),
          pointsName: customPointsName
        });
      } else {
        return t(`customer.points.${referralAction}`, {
          amount,
          formattedAmount: formatNumber(amount)
        });
      }
    }
  }
  return '';
}
//# sourceMappingURL=getCustomerRewardTitle.js.map